// Service URLs come from the environment so the same build works locally and in
// production. Override them in .env.local for local development. In production,
// use the page origin so HTTPS pages never make blocked HTTP mixed-content calls.
const browserOrigin = typeof window !== 'undefined' ? window.location.origin : '';
const browserProtocol = typeof window !== 'undefined' ? window.location.protocol : '';

// Never let a developer-only HTTP endpoint escape into an HTTPS deployment.
// Create React App loads .env.local during production builds too, so this
// runtime guard keeps the live site same-origin even if a workstation has
// localhost overrides configured.
export const chooseServiceUrl = (configuredUrl, fallbackUrl, pageProtocol = browserProtocol) => {
    if (!configuredUrl) return fallbackUrl;
    if (pageProtocol === 'https:' && /^http:\/\//i.test(configuredUrl)) return fallbackUrl;
    return configuredUrl;
};

const config = {
    STORAGE_BASE_URL: chooseServiceUrl(process.env.REACT_APP_STORAGE_BASE_URL, `${browserOrigin}/storage`),
    API_BASE_URL: chooseServiceUrl(process.env.REACT_APP_API_BASE_URL, `${browserOrigin}/api`),
    SOCKET_URL: chooseServiceUrl(process.env.REACT_APP_SOCKET_URL, browserOrigin),
};
export default config;
